import { call, put, takeLatest } from "redux-saga/effects";
import { axiosRestInstance } from "../../../common/axios";
import { adminHomeDashboardSliceAction } from "../../slices/admin-home-dashboard";
import type {
  AdminHomeDashboardAPIResponse,
  AdminHomeDashboardFilterParams,
} from "../../slices/admin-home-dashboard/Types";
import {
  adminHomeDashboardSagaActionTypes,
  getAdminHomeDashboardSagaAction,
} from "./saga-actions";

const getAdminHomeDashboardAPI = async (
  filters: AdminHomeDashboardFilterParams
) => {
  const response = await axiosRestInstance.get<AdminHomeDashboardAPIResponse>(
    "/dashboard/stats/",
    {
      params: filters,
    }
  );

  return response.data;
};

function* getAdminHomeDashboardSaga(
  action: ReturnType<typeof getAdminHomeDashboardSagaAction>
) {
  const filters = action.filters ?? {};

  try {
    yield put(adminHomeDashboardSliceAction.setAdminHomeDashboardLoading(true));
    yield put(adminHomeDashboardSliceAction.setAdminHomeDashboardError(null));

    const response: AdminHomeDashboardAPIResponse = yield call(
      getAdminHomeDashboardAPI,
      filters
    );

    if (!response?.success || !response.data) {
      throw new Error("Unable to load admin dashboard data.");
    }

    yield put(
      adminHomeDashboardSliceAction.setAdminHomeDashboardData({
        data: response.data,
        filters,
      })
    );
  } catch (error) {
    console.error(error);
    yield put(adminHomeDashboardSliceAction.clearAdminHomeDashboard());
    yield put(
      adminHomeDashboardSliceAction.setAdminHomeDashboardError(
        "Unable to load admin dashboard data."
      )
    );
  } finally {
    yield put(adminHomeDashboardSliceAction.setAdminHomeDashboardLoading(false));
  }
}

function* adminHomeDashboardSaga() {
  yield takeLatest(
    adminHomeDashboardSagaActionTypes.callGetAdminHomeDashboardSaga,
    getAdminHomeDashboardSaga
  );
}

export default adminHomeDashboardSaga;
